import type { Project } from '@/types'
import Tag from '@/components/ui/Tag'
import ScrollReveal from '@/components/ui/ScrollReveal'
import VimeoEmbed from '@/components/ui/VimeoEmbed'

interface TobiHeroProps {
  project: Project
}

export default function TobiHero({ project }: TobiHeroProps) {
  return (
    <div>
      <ScrollReveal>
        <h1 className="text-display mb-6">TOBi – Breathing Life into AI</h1>
      </ScrollReveal>

      <ScrollReveal delay={0.1}>
        <VimeoEmbed videoId={project.previewVideoId} />
      </ScrollReveal>

      <ScrollReveal delay={0.15}>
        <div className="grid grid-cols-1 md:grid-cols-[200px_1fr] gap-8 md:gap-12 mt-8">
          <div className="flex flex-col gap-6">
            <div>
              <span className="text-label uppercase tracking-widest text-text-muted">Role</span>
              <p className="text-body text-text-primary mt-1">{project.role}</p>
            </div>
            <div>
              <span className="text-label uppercase tracking-widest text-text-muted">Date</span>
              <p className="text-body text-text-primary mt-1">{project.date}</p>
            </div>
            <div>
              <span className="text-label uppercase tracking-widest text-text-muted">Tags</span>
              <div className="flex flex-wrap gap-2 mt-2">
                <Tag label="AI Character" />
                <Tag label="Lottie JSON" />
                <Tag label="Emotion Matrix" />
              </div>
            </div>
          </div>
          <p className="text-body text-text-secondary leading-relaxed">
            When I joined Vodafone, TOBi existed as a static chatbot avatar – a flat graphic with no
            animation or personality. My hypothesis was that introducing fluid, performant animation
            would make the assistant significantly more expressive and engaging, boosting conversation
            initiation rates and building critical user trust in an era when AI conversations were not
            yet widely adopted.
          </p>
        </div>
      </ScrollReveal>
    </div>
  )
}
